// Fórmula oficial de SAT (Documentación Técnica FEL, Anexo 5.4, sección 2.18):
// la Serie son los primeros 8 caracteres hexadecimales del UUID de autorización,
// y el Número es el equivalente decimal de los siguientes 8 (posiciones 9-16,
// sin los guiones). El certificador los genera así a partir del mismo UUID que
// ya nos devuelve, así que no hace falta que nos los mande aparte.
export const deriveSerieNumero = uuid => {
  if (!uuid) return null

  const hex = uuid.replace(/-/g, '').toUpperCase()
  if (hex.length < 16) return null

  return {
    serie: hex.slice(0, 8),
    numero: parseInt(hex.slice(8, 16), 16),
  }
}
